import { Form } from 'react-final-form';
import { Box, Button } from '@mui/material';

import { StaticDatePicker } from '@occc-app/design-system';
import { calcDateTime, endOfDateTime, isBeforeDateTime, startOfDateTime } from '@occc-app/lib/date';

type DateRangePickerProps = {
  show: boolean;
  startDate: Date | null;
  endDate: Date | null;
  minSelectableDate?: Date;
  maxSelectableDate?: Date;
  disableFuture?: boolean;
  onDatesChange: (startDate: Date, endDate: Date) => void;
  onClose: () => void;
};

export const DateRangePicker = ({
  show,
  startDate,
  endDate,
  minSelectableDate,
  maxSelectableDate,
  disableFuture = true,
  onDatesChange,
  onClose,
}: DateRangePickerProps) => {
  if (!show) {
    return null;
  }

  const getInitialMonth = () => {
    const now = new Date();
    if (!startDate || isBeforeDateTime(startOfDateTime(now, 'month'), startDate)) {
      return calcDateTime(now, 'sub', 1, 'month');
    }

    return startDate;
  };

  return (
    <Form
      onSubmit={(values) => {
        onDatesChange(
          startOfDateTime(values.startDate, 'day'),
          endOfDateTime(values.endDate, 'day'),
        );
        onClose();
      }}
      initialValues={{
        startDate,
        endDate,
      }}
    >
      {({ handleSubmit, values }) => (
        <Box display='flex' flexDirection='column' p={3}>
          <Box display='flex' justifyContent='space-between'>
            <StaticDatePicker
              name='startDate'
              disableFuture={disableFuture}
              disableHighlightToday
              referenceDate={getInitialMonth()}
              maxDate={calcDateTime(values.endDate, 'sub', 1, 'day')}
              minDate={minSelectableDate}
              slots={{ toolbar: () => null, actionBar: () => null }}
            />
            <StaticDatePicker
              name='endDate'
              disableFuture={disableFuture}
              disableHighlightToday
              minDate={calcDateTime(values.startDate, 'add', 1, 'day')}
              maxDate={maxSelectableDate}
              slots={{ toolbar: () => null, actionBar: () => null }}
            />
          </Box>
          <Box display='flex' justifyContent='flex-end'>
            <Button onClick={handleSubmit} variant='contained'>
              Apply
            </Button>
          </Box>
        </Box>
      )}
    </Form>
  );
};
